import {
  JSONApiRelation,
  JSONApiRelationList,
  JSONApiResourceBase,
} from '../interfaces/JSONApi.js'
import { BaseEvents } from './Events.js'

export interface Permission {
  subject: string
  action: string
}

export interface User extends JSONApiResourceBase {
  type: 'users'
  attributes: {
    username?: string
    email?: string
    password?: string
    type?: string
    status?: string
    activated?: boolean
    phoneStatus?: string
    permissions?: Permission[]
    additionalAttributes?: any
    currentOrganizationId?: number
    isStaff?: boolean
    createdAt?: string
    updatedAt?: string
    statusChangedAt?: string
  }
  relationships: {
    team?: JSONApiRelation
    roles?: JSONApiRelationList
    pauseCode: JSONApiRelation
    myTeams: JSONApiRelationList
    queues: JSONApiRelationList
    trunk: JSONApiRelation
    licenseType: JSONApiRelation
    billingOrganization: JSONApiRelation
    organizations: JSONApiRelationList
    userStatistics?: JSONApiRelation
  }
}

export enum LoginTypes {
  login = 'login',
  apiLogin = 'apiLogin',
}

export interface ApiToken extends JSONApiResourceBase {
  type: 'apiTokens'
  attributes: { name: string }
}

export interface AuthToken {
  type: string
  attributes: { token: string }
}

export interface LoginAdditionalOptions {
  type?: LoginTypes
  requestExtension?: boolean
}

export interface LoginResponse {
  token?: string
  extensionPassword: string
}

export interface UserEvent {
  eventId: string
  type: 'users'
  op: 'replace' | 'add'
  id: number
  data: {
    username: string
    email: string
    status: string
    additionalAttributes: any
  }
}

export interface UserStatusChangeEvent {
  eventId: string
  type: 'userStatusChanges'
  op: 'replace' | 'add'
  id: number
  data: {
    userId: number
    pauseCodeId: number
    status: string
    startDate: string
    endDate: string
  }
}
export interface UserEvents extends BaseEvents {
  users: UserEvent
  userStatusChanges: UserStatusChangeEvent
}
